import { IconCosmetics } from './IconCosmetics'

export default IconCosmetics
